import { ca } from '@cian/analytics';

export function trackSubmitComplaint(label: string) {
  ca('event', {
    action: 'complain_send_main_block',
    category: 'card',
    label,
    name: 'oldevent',
  });
}

export function trackSelectComplaint(label: string) {
  ca('event', {
    action: 'complain',
    category: 'Listing',
    label,
    name: 'oldevent',
  });
}
